import { API_BASE_URL } from '../utils/api';

const request = async (path, options = {}) => {
  const token = localStorage.getItem('storeToken');
  const headers = { ...(options.headers || {}) };
  if (token) headers.Authorization = `Bearer ${token}`;
  let body = options.body;
  if (body && !(body instanceof FormData)) { body = JSON.stringify(body); headers['Content-Type'] = 'application/json'; }
  const response = await fetch(`${API_BASE_URL}${path}`, { ...options, headers, body });
  const result = await response.json().catch(() => null);
  if (!response.ok || result?.status !== 'SUCCESS') throw new Error(result?.message || 'Store request failed.');
  return { data: result.data, message: result.message };
};
export const storeLogin = (payload) => request('/api/store/login', { method: 'POST', body: payload });
export const getStoreMe = () => request('/api/store/me');
export const getStoreDashboard = () => request('/api/store/dashboard');
export const storeLogout = () => request('/api/store/logout', { method: 'POST' });
export const changeStorePassword = (payload) => request('/api/store/change-password', { method: 'PATCH', body: payload });
